<template>
    <div :class="formGroupClass">
        <h4 class="pull-left visitor-title-number">
            <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
            <template v-if="isView">
                <a
                        class="link-fio"
                        target="_blank"
                        :href="searchVisitorUrl"
                >{{ visitorName }}</a>
            </template>
            <template v-else>
                {{ visitorName }}
            </template>
            <template v-if="hasErrors">
                <img :src="baseUrl + '/img/lock.png'"
                     :title="getHtml"
                     :data-original-title="imgTitle"
                     data-toggle='tooltip' class="lock-icon" data-html="true" alt="">
            </template>
        </h4>
    </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import { ApiClient } from '../../../../helpers/api-client/ApiClient'
import ErrorHelpBlock from '../../ErrorHelpBlock.vue'

export default {
  name: 'FullNameTitle',
  components: { ErrorHelpBlock },
  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],

  data: () => {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },

  props: {
    inputName: {
      default: 'fullname'
    },

    visitorName: {
      type: String
    },

    visitorPersonal: {
      type: Object
    }
  },

  computed: {
    imgTitle() {
      return this.visitorPersonal.infoBlock ? this.visitorPersonal.infoBlock : this.getErrorVisitor(this.visitorIndex, 'fullname')
    },

    searchVisitorUrl() {
      return ApiClient.getApplicationScreenUrl(this.visitorName)
    },

    getHtml() {
      if (this.visitorPersonal.infoBlock || this.getErrorVisitor(this.visitorIndex, 'fullname')) {
        const html = this.visitorPersonal.infoBlock ? this.visitorPersonal.infoBlock : this.getErrorVisitor(this.visitorIndex, 'fullname')

        return html.replace(/(<([^>]+)>)/ig, '')
      }

      return null
    }
  }
}
</script>

<style scoped>

</style>
